import { create } from 'zustand';
import { getAllTalents, GetTalentsParams } from '@libs/api/talents';
import { TalentStaffingType } from '@libs/models/talents';
import { StaffListItem } from '@libs/models/talents/talent';

type InitialState = {
  loading: boolean;
  initiated: boolean;
  load: (params?: GetTalentsParams) => Promise<void>;
  talents: StaffListItem[];
  currentSearch: string;
};

export const useShiftDrawerTalents = create<InitialState>()((set) => ({
  loading: false,
  initiated: false,
  currentSearch: '',
  talents: [],
  load: async (params) => {
    set({
      loading: true,
    });
    try {
      const talents = await getAllTalents(params);
      set({
        talents: talents,
        initiated: true,
        currentSearch: params?.search ?? '',
        loading: false,
      });
    } finally {
      set({
        loading: false,
      });
    }
  },
}));
